(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/objects/start-page-handler.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/objects/start-page-handler.js');

(function(Backbone, _, svs) {
  'use strict';
  svs.matchen = svs.matchen || {};
  svs.matchen.objects = svs.matchen.objects || {};

  svs.matchen.objects.StartPageHandler = Marionette.MnObject.extend({
    options: function() {
      return {
        hotDraws: [],
        branding: '',
        backgroundImageURL: '',
        draws: new svs.matchen.collections.Draws([])
      };
    },

    getStartPageOptions: function() {
      var drawsCollection = this.options.draws;

      return {
        generalSettings: {
          branding: this.options.branding
        },

        promoRegion: {
          matchPromo: {
            settings: new Backbone.Model({
              backgroundImageLarge: this.options.backgroundImageURL,
              noOpenDrawsText: svs.matchen.app.config.getNoOpenDrawsTxt(),
              showNoOpenDraws: !drawsCollection
            }),
            items: this.getPromoItems(this.getPromoDraws(drawsCollection))
          }
        },

        roundsRegion: {
          tabs: true,
          items: this.getRoundsItems(drawsCollection)
        },

        tabRegion: new Backbone.Model({
          items: this.options.tabs,
          buttons: [
            {
              label: 'Spela',
              inverted: true,
              callback: function() {}
            }
          ]
        }),

        footerRegion: {
          buttons: new Backbone.Collection(this.options.links)
        }
      };
    },

    getPromoDraws: function(draws) {
      var promoDraws = new svs.matchen.collections.Draws();
      var hotDraws = draws.getDrawsFromDrawNumbers(this.options.hotDraws);
      var firstDraw = draws.getFirstDrawByDate();
      var maxNumberOfDraws = this.getMaxNumberOfPromoDraws();
      var hotDraw;

      if (firstDraw) {
        promoDraws.add(firstDraw);
      }

      for (var i = 0; i < maxNumberOfDraws - 1 && i < hotDraws.length; i++) {
        hotDraw = hotDraws.at(i);
        promoDraws.add(hotDraw);
      }

      return promoDraws;
    },

    getMaxNumberOfPromoDraws: function() {
      if (svs.core.detect.formfactor.mobile()) {
        return 1;
      }
      return 3;
    },

    getPromoItems: function(draws) {
      var promoItems = new Backbone.Collection();
      var promoItem;

      draws.each(function(draw) {
        promoItem = {
          infoBar: {},
          matches: [],
          buttons: [],
          extendedTitle: {}
        };
        promoItem.showTitleBar = true;
        promoItem.infoBar.stopDateLabel = 'Spelstopp: ';
        promoItem.infoBar.label = _.contains(
          this.options.hotDraws,
          draw.get('drawNumber')
        ) ?
          'HET' :
          'NÄSTA';
        promoItem.infoBar.date = dateFns.getTime(new Date(draw.get('regCloseTime')));
        promoItem.extendedTitle.revenue = parseInt(
          draw.get('currentNetSales'),
          10
        );
        promoItem.extendedTitle.rollingPool = parseInt(
          draw.get('fund').rolloverIn,
          10
        );
        promoItem.extendedTitle.extraMoney = parseInt(draw.getExtraMoney(), 10);

        promoItem.matches = [
          {
            league: draw.getLeagueName(),
            homeTeam: draw.getHomeTeamName(),
            awayTeam: draw.getAwayTeamName(),
            info: draw.getComment(),
            flag: draw.getCountryISOCode()
          }
        ];

        promoItem.buttons = [
          {
            label: 'Spela Matchen',
            callback: function() {
              Backbone.history.navigate('spela/' + draw.get('drawNumber'), {
                trigger: true,
                replace: false
              });
            }
          }
        ];

        if (draw.supportsXperten()) {
          promoItem.buttons.push({
            label: 'PIX!',
            callback: function() {
              svs.components.Storage.browser.set(
                svs.matchen.XPERTEN,
                svs.matchen.STORAGE_NAME,
                true,
                1,
                function() {
                  Backbone.history.navigate('spela/' + draw.get('drawNumber'), {
                    trigger: true,
                    replace: false
                  });
                }
              );
            }
          });
        }

        promoItems.add(promoItem);
      }, this);

      return promoItems;
    },

    getRoundsItems: function(draws) {
      var roundsItems = new Backbone.Collection();
      var roundItem;

      draws.each(function(draw) {
        roundItem = {
          label: '',
          stopDateLabel: 'Spelstopp: ',
          stopDate: draw.get('regCloseTime'),
          revenue: parseInt(draw.get('currentNetSales'), 10),
          rollingPool: draw.getRollOverIn(),
          extraMoney: draw.getExtraMoney(),
          matches: [
            {
              league: draw.getLeagueName(),
              homeTeam: draw.getHomeTeamName(),
              awayTeam: draw.getAwayTeamName(),
              info: draw.getComment(),
              flag: draw.getCountryISOCode()
            }
          ],
          callback: function() {
            Backbone.history.navigate('spela/' + draw.get('drawNumber'), {
              trigger: true,
              replace: false
            });
          }
        };

        roundsItems.add(roundItem);
      });

      return roundsItems;
    }
  });
})(Backbone, _, svs);


 })(window);